<template>
  <base-section id="verify-policy">
    <v-container
            fluid
        >
            <v-layout
            align-center
            justify-center
            >
            <v-flex
                xs12
                sm8
                md4
            >
                <!-- <img src="../public/logo.png" width="97%"> -->
                <v-card class="elevation-12" outlined>
                <v-toolbar
                    color="primary"
                    dark
                    flat
                >
                    <v-toolbar-title>{{loading_title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                        <v-icon>mdi-check-decagram</v-icon>
                </v-toolbar>
                <v-card-text>
                    <v-form v-model="form_users" ref="form" lazy-validation>
                    <v-text-field 
                        prepend-icon="mdi-file-document-outline" 
                        v-model="users_id" 
                        :rules="users_id_rules"
                        required 
                        label="No Polis Takaful Umum"
                        type="text"
                        autofocus>
                    </v-text-field>
                    </v-form>
                    <v-btn color="secondary" rounded block @click="Login">Verifikasi Polis</v-btn>
                </v-card-text>
                <!-- <v-card-actions>
                    <span class="red--text">Version {{app_version}}</span>
                    <v-spacer></v-spacer>
                    <span @click="ForgotPassword">Forget Password</span>
                </v-card-actions> -->
                </v-card>
            </v-flex>
            </v-layout>
        </v-container>
        <v-snackbar 
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            v-model="snackbar.dialog"
            rounded = "pill"
            bottom
            >
            {{ snackbar.text }}
            <template>
            <v-btn text @click.native="snackbar.dialog = false">Close</v-btn>
            </template>
        </v-snackbar>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionVerifyPolicy',
    data: () => ({
      check_login: null,
      dialog_forgot_password: false,
      //SnackBar
      snackbar: {
        dialog: false,
        color: 'success',
        text: '',
        timeout: 3000,
      },
      //Validation Form Users
      loading_title: '',
      feeds:[],
      form_users: true,
      users_id: '',
      users_id_rules: [
        v => !!v || 'No Polis Takaful Umum is required'
      ],
    }),
    provide: {
      heading: { align: 'center' },
    },
    created () {
      this.FirstLoad()
    },
    methods: {
        FirstLoad () {
            this.loading_title   = 'Verify'
        },
        Login () {
            if (this.$refs.form.validate()) {
                this.ProcessLogin(this.users_id)
            }
        },
        ProcessLogin (verifyid) {
        //Call API Users
        this.loading_title = 'Loading...'
        let formdata = {
            url_type: 'verifypolicy',
            fastflow_verify_policy: verifyid
        }
        let param 	   = this.$functions.ParamPOST(formdata)
            this.$axios.post(this.$functions.UrlPOST('apiWriteFastFlow'),param,{
        headers: {
            'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
        })
            .then(response => {
            let feedback = response.data
            if (feedback.length > 0) {
                if (feedback[0].feedback === 'Y') {
                    this.SnackBar(true, 'success', 'Nomor Polis ditemukan', 0)
                } else {
                    this.SnackBar(true, 'error', feedback[0].feedback, 0)
                }
            } else {
                this.SnackBar(true, 'error', 'Nomor Polis '+verifyid+' Tidak ditemukan', 0)
            }
            this.loading_title = 'Verify'
        })
        .catch(e => {
            this.loading_title = 'Verify'
            this.SnackBar(true, 'error', e, 0)
        })
        },
        ForgotPassword () {
            this.dialog_forgot_password = true
            setTimeout(function(){
                document.getElementById('forgotpassword').focus()
            }, 500)
        },
        SnackBar (dialog, color, text, timeout) {
            this.snackbar.dialog  = dialog
            this.snackbar.color   = color
            this.snackbar.text    = text
            this.snackbar.timeout = timeout
        },
    },
}
</script>
